{
  "R": [0, 255],
  "G": [0, 255],
  "B": [0, 255],
  "A": [0, 128],
  "I": [0, 255]
}
